<template>
  <v-dialog v-model="isOpen" max-width="600px">
    <v-card>
      <v-card-title>
        {{$t('ProfilePage.AvatarUploader.header')}}
      </v-card-title>
      <v-row align="center" justify="center">
        <v-col class="shrink">
          <v-img height="200px" width="200px" :src="picturePreview || picturePath"></v-img>
        </v-col>
      </v-row>
      <v-card-text>
        <input ref="picture" id="avatar" type="file" name="avatar" accept="image/*" @change="handleFile">
        <span>{{$t('ProfilePage.AvatarUploader.acceptFormat', {formats: 'png, jpeg/jpg, svg'})}}</span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" :disabled="!pictureFile" @click="confirm" :loading="sendingPicture">{{$t('Global.Action.confirm')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  name: 'UserEditPictureModal',
  props: {
    show: { type: Boolean, default: false }
  },
  data: () => ({
    pictureFile: null,
    sendingPicture: false
  }),
  computed: {
    ...mapGetters('auth', [
      'picturePath'
    ]),
    ...mapState('auth', [
      'user'
    ]),
    isOpen: {
      get() {
        return this.show
      },
      set() {
        this.close()
      }
    },
    picturePreview () {
      return this.pictureFile ? URL.createObjectURL(this.$refs.picture.files[0]) : this.picturePath
    }
  },
  methods: {
    ...mapActions('auth', [
      'updatePicture'
    ]),
    handleFile () {
      this.pictureFile = this.$refs.picture.files[0]
    },
    async confirm () {
      this.sendingPicture = true
      try {
        await this.updatePicture(this.pictureFile)
        this.$store.dispatch('successMessage', this.$t('Message.Success.update'))
      } catch (error) {
        this.sendingPicture = false
        this.$store.dispatch('errorMessage', this.$t('Message.Error.update'))
        throw error
      }
      this.close()
    },
    close () {
      this.$emit('close')
      this.reset()
    },
    reset () {
      this.pictureFile = null,
      this.sendingPicture = false
    },
  }
}
</script>

<style>

</style>